/**
 * Given an array of possible title strings provided in priority order this function
 * will generate a full SEO title
 */
export const getSeoTitle = (
  titles: (string | null | undefined)[] = [],
  communityName: string,
): string => {
  for (const title of titles) {
    if (!title) {
      continue;
    }

    // Return the SEO title generated from the highest priority data present.
    return `${title} | ${communityName}`;
  }

  return communityName;
};
